import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { iconSizes } from '@vfuk/core-icon'

export const LogoWrapper = styled.span(
  (): FlattenSimpleInterpolation => css`
    display: flex;

    svg {
      ${iconSizes(5, true, 'system')}
    }
  `,
)
